// extracted by mini-css-extract-plugin
export default {"box":"carroFicha_box__oRklj","navbarScrollCustom":"carroFicha_navbarScrollCustom__pYbwm","rectangle":"carroFicha_rectangle__j42O0"};